import styled from "styled-components";

export const GeneralSettingsListModalStyles = styled.div`
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      text-transform: uppercase;
    }
  }

  .transferContainer {
    display: flex;
    gap: 16px;
    margin-top: 8px;
  }

  .transferColumn {
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    border-radius: 8px;
    overflow: hidden;
  }

  .columnHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background: ${({ theme }) => theme.colors.semantic.container.gray};
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};

    .columnLabel {
      font-weight: 600;
      font-size: 12px;
      letter-spacing: 0.3px;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }

    .columnCount {
      font-size: 11px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.semantic.text.weak};
    }
  }

  .searchWrapper {
    height: 38px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
  }

  .columnList {
    min-height: 200px;
    max-height: 320px;
    overflow-y: auto;
  }

  .transferItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: ${({ theme }) => theme.colors.accent[50]};
    }

    .itemName {
      font-size: 13px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }

    .actionIcon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      font-size: 18px;
      font-weight: 400;
      line-height: 1;
      transition: all 0.15s ease;
      flex-shrink: 0;
    }

    .addIcon {
      color: ${({ theme }) => theme.colors.accent[500]};
      background: ${({ theme }) => theme.colors.accent[50]};
    }

    .removeIcon {
      color: ${({ theme }) => theme.colors.semantic.text.weak};
      background: transparent;
      border: 1.5px solid ${({ theme }) => theme.colors.semantic.separator};
    }

    &:hover .addIcon {
      background: ${({ theme }) => theme.colors.accent[200]};
      color: ${({ theme }) => theme.colors.accent[800]};
    }

    &:hover .removeIcon {
      color: ${({ theme }) => theme.colors.semantic.status.error};
      border-color: ${({ theme }) => theme.colors.semantic.status.error};
      background: #FEF2F2;
    }
  }

  .emptyState {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 16px;
    text-align: center;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-size: 12px;
  }

  .footer {
    display: flex;
    justify-content: flex-end;

    .submitButton {
      border-radius: 6px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.1px;
      padding: 10px 18px;
    }
  }
`;
